import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { synthesizePrompt } from '../../services/promptSynthesizer';
import { useToolStore } from '../../store/useToolStore';

const Console: React.FC = () => {
    const [input, setInput] = useState('');
    const [logs, setLogs] = useState<string[]>([]);

    // Connect to global store
    const setPrompt = useToolStore((state) => state.setPrompt);
    const triggerGeneration = useToolStore((state) => state.triggerGeneration);

    const handleSend = () => {
        if (!input.trim()) return;

        const finalPrompt = synthesizePrompt(input);

        // Log the action
        setLogs(prev => [...prev, `User: ${input}`, `System: Parsing architectural intent...`, `System: Configuring atmosphere parameters...`, `System: Initiating Generation Sequence...`]);

        // Update global store to trigger EditorTool
        setPrompt(finalPrompt);
        triggerGeneration();

        setInput('');
    };

    return (
        <div className="h-[200px] bg-black border-t border-zinc-800 flex flex-col z-20 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]">
            {/* Conversation Log */}
            <div className="flex-1 overflow-y-auto p-6 space-y-3 font-mono text-[10px] tracking-wide custom-scrollbar">
                <div className="text-zinc-600 italic border-l-2 border-zinc-800 pl-3">System: Ready for visualization sequence...</div>
                {logs.map((log, i) => (
                    <div key={i} className="text-zinc-400 border-b border-zinc-900 pb-2 whitespace-pre-wrap leading-relaxed animate-in fade-in slide-in-from-bottom-2 duration-300">
                        {log}
                    </div>
                ))}
            </div>

            {/* Input Area */}
            <div className="p-4 bg-black border-t border-zinc-900 flex items-center space-x-4">
                <div className="flex-1 relative group">
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                        placeholder="Describe your architectural vision... (e.g., 'Modernist villa in Swiss Alps, evening light')"
                        className="w-full bg-zinc-900/50 border border-zinc-800 rounded-xl py-4 px-6 text-sm text-zinc-200 placeholder:text-zinc-700 focus:outline-none focus:border-zinc-600 focus:bg-zinc-900 transition-all font-light tracking-wide shadow-inner"
                    />
                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-[10px] text-zinc-700 uppercase font-bold tracking-widest hidden group-hover:block transition-all">
                        AI Enabled
                    </div>
                </div>
                <button
                    onClick={handleSend}
                    className="p-4 bg-zinc-100 text-black rounded-xl hover:bg-white hover:scale-105 active:scale-95 transition-all shadow-lg hover:shadow-zinc-700/20"
                >
                    <Send size={18} />
                </button>
            </div>
        </div>
    );
};

export default Console;
